import React from "react";

export default function EmojiReactions() {
	return <div>EmojiReactions</div>;
}
